import { render } from "./NavPill.vue?vue&type=template&id=64a6a6c6"
import script from "./NavPill.vue?vue&type=script&lang=js"
export * from "./NavPill.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__